module.exports = __webpack_public_path__ + "img/generali-sigorta.dbdfdc50.png";